import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateMaterialMutation as _UpdateMaterialMutation,
  UpdateMaterialInput,
} from '../../../gql/graphql';

const UpdateMaterialMutation = graphql(`
  mutation UpdateMaterial($input: UpdateMaterialInput!) {
    updateMaterial(input: $input) {
      id
    }
  }
`);

const useUpdateMaterial = (
  options?: UseMutationOptions<
    _UpdateMaterialMutation,
    unknown,
    UpdateMaterialInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UpdateMaterialMutation, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        predicate: (query) => {
          // A material price change recomputes the price of any line item
          // (materials list, estimate and proposal lines) that references the
          // material, so invalidate the estimate and proposal builder caches
          // alongside the list.
          return (
            (query.queryKey[0] === 'project' &&
              (query.queryKey[2] === 'materialsList' ||
                query.queryKey[2] === 'estimates')) ||
            query.queryKey[0] === 'proposals'
          );
        },
      });
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};

export default useUpdateMaterial;
